import { ConfettiDropperService } from './confetti-dropper.service';
import { TranslateService } from '@ngx-translate/core';
import {
  Component,
  Input,
  AfterViewInit,
  OnDestroy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { ConfettiParticle } from './confetti-dropper.model';

@Component({
    selector: 'dgx-confetti-dropper',
    templateUrl: './confetti-dropper.component.html',
    styleUrls: ['./confetti-dropper.component.scss'],
    standalone: false
})
export class ConfettiDropperComponent implements AfterViewInit, OnDestroy {
  @Input() dropDuration: number = 5;
  @Input() maxParticles: number = 40;
  @Input() colorIncrement: number = 10;
  @ViewChild('canvas') public canvasRef: ElementRef<HTMLCanvasElement>;

  public title: string = this.translate.instant('Core_Confetti');

  private context: CanvasRenderingContext2D;
  private particleList: ConfettiParticle[];

  constructor(
    private translate: TranslateService,
    private confettiDropperService: ConfettiDropperService,
    private elementRef: ElementRef
  ) {}

  ngAfterViewInit(): void {
    this.start();
  }

  public start(): void {
    // Start the confetti drop a little delayed so the container has height and width
    setTimeout(() => {
      this.initializeContext();
      this.initializeParticles();
      return this.confettiDropperService.startConfetti(
        this.context,
        this.particleList
      );
    }, 500);

    // Set a timeout to deactivate automatically based on the dropDuration time
    setTimeout(() => this.deactivate(), this.dropDuration * 1500);
  }

  public stop(): void {
    this.confettiDropperService.stopConfetti(this.context);
  }

  public deactivate(): void {
    this.confettiDropperService.deactivateConfetti();
  }

  ngOnDestroy(): void {
    this.stop();
  }

  private initializeContext(): void {
    const canvas = this.canvasRef.nativeElement;
    this.context = canvas.getContext('2d');

    // set the canvas area to equal the container; using css will just
    // stretch the canvas out so we set it manually first
    this.context.canvas.height = this.elementRef.nativeElement.clientHeight;
    this.context.canvas.width = this.elementRef.nativeElement.clientWidth;
  }

  private initializeParticles() {
    this.particleList = this.confettiDropperService.createParticleList({
      colorIncrement: this.colorIncrement,
      maxParticles: this.maxParticles,
      canvas: this.context.canvas,
    });
  }
}
